// extracted by mini-css-extract-plugin
export var circularArcsChart = "circular-arcs-module--circularArcsChart--21edc";